import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/components/GTMErrorPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/components/GTMPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/components/GTMViewItemList.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/hooks/useGTMPromotionBanner.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/hooks/useGTMReadCards.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/hooks/useLandingProductGTM.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/lib/events.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/gtm/src/lib/promotion.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/MindboxPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/scriptMindbox.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/landing/page/bioderma_sebium/src/lib/FeatureLandingPageBiodermaSebium.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/lib/FeatureProductCatalogBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/util/parseAsObject.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/icons/check24.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/icons/close24.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ClientStoreProduct"] */ "/app/packages/libs/fo/store/product/src/lib/Client.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/store/product/src/lib/store.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/layout/catalog/src/lib/UiProductLayoutCatalog.tsx");
